export default "images/html5-logo.png";